/* eslint-disable */
export default [
  {
    path: '/public/home',
    name: 'cont-public',
    component: () => import('@/views/cont-public/home/Index'),
    meta: {
      layout: 'wr',
      resource: 'public',
      action: 'read',
    },
  },
  {
    path: '/public/login',
    name: 'cont-login',
    component: () => import('@/views/cont-public/auth/index'),
    meta: {
      layout: 'wr',
      resource: 'Auth',
      action: 'read',
    },
  },

  {
    path: '/public/register',
    name: 'cont-register',
    component: () => import('@/views/cont-public/auth/register'),
    meta: {
      layout: 'wr',
      resource: 'public',
      action: 'read',
    },
  },
  {
    path: '/public/find-quotation',
    name: 'cont-register-quotation',
    component: () =>
      import('@/views/cont-public/public-find-quotation'),
    meta: {
      layout: 'full',
      resource: 'public',
      action: 'read',
    },
  },
  {
    path: '/public/schedule-list',
    name: 'public-schedule-list',
    component: () =>
      import('@/views/cont-public/schedule-list'),
    meta: {
      layout: 'full',
      resource: 'public',
      action: 'read',
    },
  },
  {
    path: '/why-wr1',
    name: 'why-customers',
    component: () => import('@/views/cont-public/why-us'),
    meta: {
      layout: 'wr',
      resource: 'public',
      action: 'read',
    },
  },
  // {
  //   path: '/why-wr1/:folder',
  //   name: 'why-customers-folder',
  //   component: () => import('@/views/cont-public/why-us'),
  //   meta: {
  //     layout: 'wr',
  //     resource: 'public',
  //     action: 'read',
  //     contentRenderer: 'sidebar',
  //     contentClass: 'why-application',
  //     navActiveLink: 'why-wr1',
  //   },
  // },

  {
    path: '/why-wr1/:folder',
    name: 'why-customers-folder',
    component: () => import('@/views/cont-public/why-us'),
    meta: {
      layout: 'wr',
      resource: 'Auth',
      action: 'read',
      contentRenderer: 'sidebar',
      contentClass: 'why-application',
      navActiveLink: 'why-wr1',
    },
    beforeEnter(to, _, next) {
      if (
        [
          'story',
          'network',
          'management-philosophy',
          'corporate-social-responsibility',
        ].includes(to.params.folder)
      )
        next();
      else next({ name: 'error-404' });
    },
  },

  {
    path: '/core-service',
    name: 'core-service-customers',
    component: () => import('@/views/cont-public/core-service'),
    meta: {
      layout: 'wr',
      resource: 'public',
      action: 'read',
    },
  },
  {
    path: '/core-service/:folder',
    name: 'core-service-folder',
    component: () => import('@/views/cont-public/core-service'),
    meta: {
      layout: 'wr',
      resource: 'public',
      action: 'read',
      contentRenderer: 'sidebar',
      contentClass: 'why-application',
      navActiveLink: 'core-service',
    },
  },
  {
    path: '/promotion',
    name: 'promotion',
    component: () => import('@/views/others/ComingSoon'),
    meta: {

      resource: 'public',
      action: 'read',

    },
  },
  //guidelines
  {
    path: '/guidelines',
    name: 'guidelines',
    component: () => import('@/views/others/ComingSoon'),
    meta: {

      resource: 'public',
      action: 'read',

    },
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/others/ComingSoon'),
    meta: {

      resource: 'public',
      action: 'read',

    },
  },
  {
    path: '/history',
    name: 'history',
    component: () => import('@/views/others/ComingSoon'),
    meta: {

      resource: 'public',
      action: 'read',

    },
  },
  {
    path: '/paid',
    name: 'Paid',
    component: () => import('@/views/others/ComingSoon'),
    meta: {

      resource: 'public',
      action: 'read',

    },
  },
  {
    path: '/unpaid',
    name: 'unpaid',
    component: () => import('@/views/others/ComingSoon'),
    meta: {

      resource: 'public',
      action: 'read',

    },
  }, {
    path: '/setting',
    name: 'setting',
    component: () => import('@/views/others/ComingSoon'),
    meta: {

      resource: 'public',
      action: 'read',

    },
  },
];
